(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tremance-size-chart"] && !Shopify.designMode) return;
  try {
    (() => {
  const convert = (value, unit) => unit === 'cm' ? value * 2.54 : value;
  const fmt = (value, unit) => convert(value, unit).toFixed(unit === 'cm' ? 1 : 2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
  const range = (min, max, unit) => fmt(min, unit) + '–' + fmt(max, unit);
  const renderRows = (tbody, rows, kind, unit, selected) => {
    if (!tbody) return;
    tbody.innerHTML = rows.map(row => {
      const values = kind === 'jacket'
        ? [row.size, range(row.bodyMin,row.bodyMax,unit), fmt(row.chest,unit), fmt(row.waist,unit), fmt(row.shoulder,unit), fmt(row.upperArm,unit), fmt(row.sleeve,unit), fmt(row.length,unit)]
        : [row.size, range(row.bodyMin,row.bodyMax,unit), fmt(row.waist,unit), fmt(row.hip,unit), fmt(row.thigh,unit), fmt(row.opening,unit), fmt(row.rise,unit), fmt(row.inseam,unit)];
      return '<tr data-size="' + row.size + '" class="' + (row.size === selected ? 'is-selected' : '') + '">' + values.map(value => '<td>' + value + '</td>').join('') + '</tr>';
    }).join('');
  };
  const init = root => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const jacketRows = JSON.parse(root.querySelector('[data-jacket-size-data]').textContent);
    const pantRows = JSON.parse(root.querySelector('[data-pant-size-data]').textContent);
    const jacketBody = root.querySelector('[data-jacket-rows]');
    const pantBody = root.querySelector('[data-pant-rows]');
    const jacketLabel = root.querySelector('[data-selected-jacket]');
    const pantLabel = root.querySelector('[data-selected-pant]');
    const picker = root.parentElement.querySelector('variant-picker');
    let jacket = root.dataset.initialJacket || jacketRows[0].size;
    let pant = root.dataset.initialPant || pantRows[0].size;
    let unit = 'inch';
    const readSelection = () => {
      if (!picker) return;
      picker.querySelectorAll('fieldset input:checked').forEach(input => {
        if (input.dataset.optionName === 'Jacket Size') jacket = input.value;
        if (input.dataset.optionName === 'Pant Waist' || input.dataset.optionName === 'Pants Size') pant = input.value;
      });
      picker.querySelectorAll('select').forEach(select => {
        const option = select.selectedOptions[0];
        if (option?.dataset.optionName === 'Jacket Size') jacket = select.value;
        if (option?.dataset.optionName === 'Pant Waist' || option?.dataset.optionName === 'Pants Size') pant = select.value;
      });
    };
    const update = () => {
      readSelection();
      if (jacketLabel) jacketLabel.textContent = jacket;
      if (pantLabel) pantLabel.textContent = pant;
      renderRows(jacketBody,jacketRows,'jacket',unit,jacket);
      renderRows(pantBody,pantRows,'pant',unit,pant);
    };
    root.querySelectorAll('[data-unit]').forEach(button => button.addEventListener('click', () => {
      unit = button.dataset.unit;
      root.querySelectorAll('[data-unit]').forEach(item => item.setAttribute('aria-pressed',String(item === button)));
      update();
    }));
    const dialog = root.querySelector('[data-size-guide-dialog]');
    root.querySelector('[data-open-size-guide]')?.addEventListener('click', () => dialog?.showModal());
    root.querySelector('[data-close-size-guide]')?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    update();
    if (picker) picker.addEventListener('change', update);
  };
  const boot = () => document.querySelectorAll('[data-tremance-size-chart]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
  } catch(e) { console.error(e); }
})();

})();
